// Import the functions you need from the SDKs you need

import firebase from 'firebase/compat/app';

// Your web app's Firebase configuration

let apiKey = process.env.VUE_APP_API_KEY || 'AIzaSyDea_cA62NBrWNgK3Nc7LpUggMFmfOEev4'
let authDomain = process.env.VUE_APP_AUTH_DOMAIN || 'vuejs-e38f4.firebaseapp.com'
let projectId = process.env.VUE_APP_PROJECT_ID || 'vuejs-e38f4'
let storageBucket = process.env.VUE_APP_STORAGE_BUCKET || 'vuejs-e38f4.firebasestorage.app'
let messagingSenderId = process.env.VUE_APP_MESSAGING_SENDER_ID || '793777030928'
let appId = process.env.VUE_APP_APP_ID || '1:793777030928:web:93d9db597d73fd97ca4795'
// let apiKey = process.env.VUE_APP_API_KEY || 'AIzaSyBOWUBvR_mErychu0djGvsjEq-k9hb96Mk'
// let authDomain = process.env.VUE_APP_AUTH_DOMAIN || 'bothapp-395aa.firebaseapp.com'
// let projectId = process.env.VUE_APP_PROJECT_ID || 'bothapp-395aa'
// let storageBucket = process.env.VUE_APP_STORAGE_BUCKET || 'bothapp-395aa.firebasestorage.app'
// let messagingSenderId = process.env.VUE_APP_MESSAGING_SENDER_ID || '718317018351'
// let appId = process.env.VUE_APP_APP_ID || '1:718317018351:web:a118a6a9ff642d9a7b8f1a'
console.log(authDomain)
const firebaseConfig = {
  apiKey: apiKey,
  authDomain: authDomain,
  projectId: projectId,
  storageBucket: storageBucket,
  messagingSenderId: messagingSenderId,
  appId: appId
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig)